import {FiltersReturnModel} from '@features/orders/interfaces';
import {userStorage} from './user';

export interface OrdersReturnsFilters {
    filtersReturns: FiltersReturnModel;
}

const ORDERS_RETURNS_FILTERS_KEY = 'ordersReturnsFilters';

class OrdersReturnsFiltersStorage {
    getUserLogin = (): string => {
        return (
            `${ORDERS_RETURNS_FILTERS_KEY}_${userStorage.get()?.login}` ||
            ORDERS_RETURNS_FILTERS_KEY
        );
    };

    set = (filtersReturns: FiltersReturnModel) =>
        localStorage.setItem(this.getUserLogin(), JSON.stringify(filtersReturns));

    get = (): FiltersReturnModel | null => {
        const filters = localStorage.getItem(this.getUserLogin());
        return filters ? JSON.parse(filters) : null;
    };

    clear = () => localStorage.removeItem(this.getUserLogin());
}

export const ordersReturnsFiltersStorage = new OrdersReturnsFiltersStorage();
